import { useEffect, useState } from 'react';

export const useCanAddFilters = <T>(
  name: string,
  type: T | undefined,
  isCohortBuilderItemInUse: boolean,
  exclude?: T[]
) => {
  /** Indicates whether the add filter buttons are enabled */
  const [enableAddFilterButtons, setEnableAddFilterButtons] = useState<boolean>(false);

  /** The title tag (tooltip) text to be rendered for the action item buttons */
  const [addFilterButtonTitleText, setAddFilterButtonTitleText] = useState<string | undefined>(
    undefined
  );

  /** The title tag (tooltip) text to be rendered for the type dropdown field */
  const [typeInputFieldTitleText, setTypeInputFieldTitleText] = useState<string | undefined>(
    undefined
  );

  useEffect(() => {
    setEnableAddFilterButtons(name !== '' && !!type && exclude?.includes(type) !== true);

    setAddFilterButtonTitleText(() => {
      if (!name || !type) {
        return 'Please enter a name and select a type to add a filter.';
      }
      return undefined;
    });

    setTypeInputFieldTitleText(() => {
      if (!name) {
        return 'Please enter a name to select a type.';
      }
      if (isCohortBuilderItemInUse) {
        return 'You cannot change the type of an item that is already in use.';
      }
      return undefined;
    });
  }, [exclude, name, type, isCohortBuilderItemInUse]);

  return {
    enableAddFilterButtons,
    addFilterButtonTitleText,
    typeInputFieldTitleText,
  };
};
